import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import { Output } from '@angular/core';
import { DataService } from '../../data.service';
import { FileUploader } from 'ng2-file-upload';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { QueryBuilder, QueryService } from '../../@tools/query';
import { CONFIG } from '../../config';
import { DatePickerController } from '../date-picker/date-picker.service';


@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: [ './table.component.scss' ]
})
export class TableComponent implements OnInit {

    @Input() table;
    @Input() full;
    @Input() primaryKey;
    @Input() dataSource;
    @Output() onSearch: EventEmitter<any> = new EventEmitter();

    public VIEW = 0;
    public EDIT = 1;
    public DELETE = 2;


    rowIndex = -1;
    new_model: { [k: string]: any } = {};
    backup;

    pattern = {
        string: '^.{0,255}$',
        text: '^.*$',
        integer: '^[0-9]*$',
        float: '^([0-9]+\\.)?[0-9]*$',
    };

    showRelation = false;
    relation_model = '';
    relation_field = '';
    relation_to = '';
    relation_row;
    url = CONFIG.url;

    file_fields: { [k: string]: File } = {};


    constructor(private query: QueryService, private DATA: DataService) {
    }

    ngOnInit() {
    }

    defaultOrder() {
        return 0;
    }

    toggleRow(row) {
        row.selected = !row.selected;
    }

    clear() {
        this.new_model = {};
    }

    create() {
        let id = this.primaryKey;

        this.query.post(this.table, this.new_model).then(response => {
            this.new_model = {};

            let qb = new QueryBuilder(this.table);
            this.DATA.applyWith(this.table, qb);

            this.query.get(qb, response[id]).then(resp2 => {
                this.dataSource.push(resp2);
                this.DATA.applyModels(this.table, this.dataSource);
                this.showRelation = false;
            });
        });
    }

    copy(row, index) {
        let data = { ...row };
        delete data[this.primaryKey];
        this.query.post(this.table, data).then(result => {
            this.dataSource.push(result);
            this.DATA.applyModels(this.table, this.dataSource);
            this.set_edit(this.dataSource[this.dataSource.length - 1]);
        });
    }

    openPictureDialog(picture): void {
        // this.dialog.open(PictureDialog, {
        //     data: CONFIG.url + picture
        // });
    }

    openRelationDialog(data): void {
        // this.dialog.open(RelationComponent, {
        //     data: data
        // });
    }

    set_edit(row) {
        if (row.state != this.EDIT) {
            row.backup = Object.assign({}, row);
            row.state = this.EDIT;
        }
    }

    apply_edit(row, index) {
        let id = this.primaryKey;

        this.query.put(this.table, row[id], row.backup).subscribe(response => {
            row.state = this.VIEW;
            delete row.backup;
            let qb = new QueryBuilder(this.table);
            this.DATA.applyWith(this.table, qb);

            this.query.get(qb, response[id]).then(resp2 => {
                this.dataSource[index] = resp2;
                this.DATA.applyModels(this.table, this.dataSource);
                this.showRelation = false;
            });
        });
    }

    cancel_edit(row) {
        row.state = this.VIEW;
        delete row.backup;
        this.showRelation = false;
    }

    set_delete(row) {
        row.state = this.DELETE;
    }

    apply_delete(row, index) {
        let id = this.primaryKey;
        this.query.delete(this.table, row[id]).then(response => {
            this.dataSource.splice(index, 1);
            this.showRelation = false;
        });
    }

    cancel_delete(row) {
        row.state = this.VIEW;
        this.showRelation = false;
    }

    search() {
        if (this.onSearch) {
            this.onSearch.emit(this.new_model);
        }
    }

    changeSelect(field, value) {
        this.new_model[field] = value;
    }

    showRelationTable(type, field, row) {
        let rel = type.split(':');
        this.relation_model = rel[1];       // какая модель
        this.relation_field = rel[2];       // из какого поля подставлять
        this.relation_to = field;           // в какое поле подставлять
        this.relation_row = row;
        this.showRelation = true;
    }

    onChangeId(data) {
        this.relation_row[this.relation_to] = data.id;
        this.showRelation = false;
    }

    fileChanged(field, row, fileList: FileList) {
        if (fileList.length > 0) {
            let file: File = fileList[0];
            row[field] = file;

            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (_event) => {
                row['preview_' + field] = reader.result;
            };
        }
    }

    getName(row, field) {
        return row.names && row.names[field] && row.names[field](row) || row[field];
    }

    relatedTo(type) {
        return type.split(':')[2];
    }

    rowStyle(index, row) {
        if (row.selected) {
            return 'selected-row';
        }
        if (row.state == this.DELETE) {
            return 'deleting-row';
        }
        if (row.state == this.EDIT) {
            return 'editing-row';
        }

        return index % 2 == 0 ? 'even' : 'odd';
    }

    // preview(files) {
    //     if (files.length === 0)
    //         return;
    //
    //     var mimeType = files[0].type;
    //     if (mimeType.match(/image\/*/) == null) {
    //         return;
    //     }
    //
    //     var reader = new FileReader();
    //     reader.readAsDataURL(files[0]);
    //     reader.onload = (_event) => {
    //         this.imgURL = reader.result;
    //     }
    // }
}

// @Component({
//     selector: 'picture-dialog',
//     template: `
//         <button style="padding: 0">
//             <img src="{{ data }}"
//                  style="display: block; max-width: 700px; max-height: 700px; width: auto; height: auto;">
//             <br>
//             <a href="{{ data }}" target="_blank" (click)="$event.stopPropagation()">Открыть оригинал</a>
//         </button>`,
// })
// export class PictureDialog {
//     constructor(public data: string) {
//     }
// }
